<app-handover-initiate-well-search style="width: 100%;" (searchTextToEmit)="getSearchText($event)"></app-handover-initiate-well-search>
<div class="loading-shade" *ngIf="isLoadingWells">
    <mat-spinner *ngIf="isLoadingWells"></mat-spinner>
</div>

<div class="div-table">
    <mat-paginator [hidePageSize]="true" [pageSize]="10" [length]="totalWells" (page)="getPage($event)" *ngIf="wells.data.length > 0"></mat-paginator>

    <table mat-table [dataSource]="wells" *ngIf="totalWells != undefined" multiTemplateDataRows>
        <ng-container matColumnDef="wellId">
            <mat-header-cell *matHeaderCellDef> wellId </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.wellId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="wellCommonName">
            <mat-header-cell *matHeaderCellDef> Pozo </mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell-table first-column-cell-table"> {{element.wellCommonName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="project">
            <mat-header-cell *matHeaderCellDef><span class="padding-cell">Yacimiento</span></mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell-table"><span class="padding-cell">{{element.project}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="ug">
            <mat-header-cell *matHeaderCellDef><span class="padding-cell">UG</span></mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell-table"><span class="padding-cell">{{element.ug}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="districtName">
            <mat-header-cell *matHeaderCellDef><span class="padding-cell"></span>Distrito/Asset </mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell-table"><span class="padding-cell"></span>{{element.districtName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastHandover">
            <mat-header-cell *matHeaderCellDef><span class="padding-cell">Último Handover</span></mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell-table">
                <span *ngIf="element.lastHandover" class="padding-cell">{{ 'De ' + element.lastHandover.fromOperationalArea +
                    ' a ' + element.lastHandover.toOperationalArea}}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="initiateHandover">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element; let i = dataIndex" class="cell-table last-column-cell-table">
                <button *ngIf="havePermissionViewHoHistory" mat-mini-fab (click)="element.isExpanded = !element.isExpanded" 
                            [ngClass]="{'history-button': element.haveHistoricalHandovers, 'history-button-disabled': !element.haveHistoricalHandovers}" 
                        [title]="element.haveHistoricalHandovers ? !element.isExpanded ? 'Ver Historial de Handovers': 'Dejar de ver Historial de Handovers' : 'No posee Historial de Handovers'" 
                        [disabled]="!element.haveHistoricalHandovers">
                    <mat-icon class="material-icons-outlined">history</mat-icon>
                    <mat-icon *ngIf="!element.isExpanded" class="material-icons-outlined icon-ex">
                        expand_more
                    </mat-icon>
                    <mat-icon *ngIf="element.isExpanded" class="material-icons-outlined icon-ex">
                        expand_less
                    </mat-icon>
                </button>
                <button *ngIf="havePermissionCreate(element.ug)" mat-mini-fab [matMenuTriggerFor]="handoverMenu" class="initiate-ho-icon" [disabled]="inititateHoButtonDisabled(element.districtId, element.haveOperationsReceivers, element.ug, i)" [title]="titleInitiateHandoverButton[i]">
                    <mat-icon svgIcon="handover-icon"></mat-icon>
                    <span class = "no-wrap-text">Iniciar Handover</span>
                </button>
                <mat-menu class="mat-menu-ho" #handoverMenu="matMenu" yPosition="below">
                    <div *ngFor="let ho of handoverTypesArea"  [title]="titleInitiateHandoverMenuButton(element.haveOperationsReceivers, ho, element)">
                        <button *ngIf="ho.handoverTypeId !== HotypeId" class="button-menu-ho" mat-menu-item (click)="initiateHandover(element, ho.handoverTypeAreaReasonid, ho.type, ho.handoverTypeId, ho.fromAreaId);"
                            [disabled]="inititateHoMenuButtonDisabled(element.haveOperationsReceivers, ho, element)">A {{ho.toAreaName}} ({{ho.type}})</button>
                            <button *ngIf="ho.handoverTypeId == HotypeId" class="button-menu-ho" mat-menu-item (click)="initiateHandover(element, ho.handoverTypeAreaReasonid, ho.type, ho.handoverTypeId, ho.fromAreaId);"
                            [disabled]="inititateHoMenuButtonDisabled(element.haveOperationsReceivers, ho, element)">HLOC a {{ho.toAreaName}} ({{ho.type}})</button>
                    </div>
                    <button *ngIf="handoverToOperations?.length" class="ho-submenu button-menu-ho hide-mat-mdc-menu-submenu-icon" mat-menu-item [matMenuTriggerFor]="operations">A Operations</button>
                </mat-menu>
                <mat-menu class="mat-menu-ho" #operations="matMenu" xPosition="before" yPosition="below">
                    <button class="button-menu-ho" mat-menu-item *ngFor="let ho of handoverToOperations"
                        (click)="initiateHandover(element, ho.handoverTypeAreaReasonid, ho.type, ho.handoverTypeId, ho.fromAreaId);"
                        [disabled]="isInitiateHandoverToOperationsDisabled(ho, element)"
                        title="{{initiateHandoverToOperationsTitle(ho, element)}}">
                            {{ho.reasonName}} ({{ho.type}})
                    </button>
                </mat-menu>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let element">
                <div class="handover-history-element-detail" [@detailExpand]="element.isExpanded ? 'expanded' : 'collapsed'">
                    <app-handover-history *ngIf="element.isExpanded" [wellId]="element.wellId" [wellCommonName]="element.wellCommonName" [handoversCountToShow]="handoversCountToShow" [showHeader]="showHandoverHistoryHeader"></app-handover-history>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="6">
                <span>No existen registros para la búsqueda indicada.</span>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns;"></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="handover-history-detail-row"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooter}"></mat-footer-row>
    </table>
</div>